import type { Usage, BomUsage } from '../../gql';

import { randNumber, randUuid } from '@ngneat/falso';

import { mockUsage } from './mockUsage';

const mockUsages: Array<Usage> = [
    mockUsage({
        usagePublicId: '1',
        usageName: 'Shell',
        displayOrder: 1,
    }),
    mockUsage({
        usagePublicId: '2',
        usageName: 'Padding',
        displayOrder: 3,
    }),
    mockUsage({
        usagePublicId: '3',
        usageName: 'Lining',
        displayOrder: 2,
    }),
];

const randomMockUsage = (): Usage =>
    mockUsages[randNumber({ max: mockUsages.length - 1 })];

const mockBomUsage = (override?: Partial<BomUsage>): BomUsage => ({
    bomUsagePublicId: randUuid(),
    usage: mockUsages[randNumber({ max: mockUsages.length - 1 })],
    bomPlacements: [],
    ...override,
    ['__typename']: 'BomUsage',
});

export { mockBomUsage, randomMockUsage };
